// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"259":"b4518183","856":"1b24ef3a","935":"cf5cbdb7"}[chunkId] + ".js";
};